import HelpPage, { HelpPageProps } from './HelpPage';

export type { HelpPageProps };
export default HelpPage;
